import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useShowDebugging } from '~/functions/accounts';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricValueLock',
  props: {
    value: {
      type: Boolean
    },
    item: null,
    items: null,
    displayedReferencePeriods: null
  },
  emits: ["input", "submit"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var showDebugging = useShowDebugging();
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var lockOperation = ref('FREEZE');
    var lockScope = ref('TARGET');
    var lockYears = ref([]);
    var lockLevel = ref('PORTFOLIO');
    var lockReason = ref('');
    var showReasonValidation = ref(false);
    var normalizeUserId = function normalizeUserId(id) {
      if (id === null || id === undefined) return null;
      var normalized = String(id).trim();
      return normalized || null;
    };
    var localMetricValues = ref([]);
    var activeItems = computed(function () {
      if (props.items && props.items.length) return props.items;
      return props.item ? [props.item] : [];
    });
    var lockStatusRows = computed(function () {
      var metricValues = _toConsumableArray(localMetricValues.value).filter(function (mv) {
        return Boolean(mv.period);
      });
      metricValues.sort(function (a, b) {
        return (a.period || '').localeCompare(b.period || '');
      });
      return metricValues.map(function (mv) {
        var period = mv.period || '';
        return {
          period: period,
          targetLocked: Boolean(mv.targetLocked),
          actualLocked: Boolean(mv.actualLocked),
          lockedReason: mv.lockedReason || null,
          lockedByUserId: normalizeUserId(mv.lockedByUserId),
          lockLevel: mv.lockLevel || null
        };
      });
    });
    var lockingLevelOptions = computed(function () {
      var options = [{
        text: 'Portfolio',
        value: 'PORTFOLIO'
      }];
      if (showDebugging.value) {
        options.push({
          text: 'IX Admin',
          value: 'IX_ADMIN'
        });
      }
      return options;
    });
    var trimmedLockReason = computed(function () {
      return lockReason.value.trim();
    });
    var hasReason = computed(function () {
      return Boolean(trimmedLockReason.value);
    });
    var lockReasonErrors = computed(function () {
      return showReasonValidation.value && !hasReason.value ? [String(proxy.$t('reasonRequired'))] : [];
    });
    watch(function () {
      return props.value;
    }, function (open) {
      var _props$item;
      if (!open) return;
      lockOperation.value = 'FREEZE';
      lockScope.value = 'TARGET';
      lockYears.value = _toConsumableArray(props.displayedReferencePeriods || []);
      lockLevel.value = 'PORTFOLIO';
      lockReason.value = '';
      showReasonValidation.value = false;
      localMetricValues.value = _toConsumableArray(((_props$item = props.item) === null || _props$item === void 0 ? void 0 : _props$item.metricValues) || []).map(function (mv) {
        return {
          period: mv.period || null,
          targetLocked: mv.targetLocked,
          actualLocked: mv.actualLocked,
          lockedReason: mv.lockedReason || null,
          lockedByUserId: normalizeUserId(mv.lockedByUserId),
          lockLevel: mv.lockLevel || null
        };
      });
    });
    watch(function () {
      var _props$item2;
      return (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.metricValues;
    }, function (values) {
      localMetricValues.value = _toConsumableArray(values || []).map(function (mv) {
        return {
          period: mv.period || null,
          targetLocked: mv.targetLocked,
          actualLocked: mv.actualLocked,
          lockedReason: mv.lockedReason || null,
          lockedByUserId: normalizeUserId(mv.lockedByUserId),
          lockLevel: mv.lockLevel || null
        };
      });
    }, {
      deep: true
    });
    var submit = function submit() {
      showReasonValidation.value = true;
      if (!lockYears.value.length || !hasReason.value) return;
      var reason = trimmedLockReason.value;
      var level = showDebugging.value ? lockLevel.value : 'PORTFOLIO';
      var shouldLock = lockOperation.value === 'FREEZE';
      var selectedPeriods = new Set(lockYears.value.map(String));
      var targetAffected = lockScope.value === 'TARGET' || lockScope.value === 'TARGET_AND_ACTUAL';
      var actualAffected = lockScope.value === 'ACTUAL' || lockScope.value === 'TARGET_AND_ACTUAL';
      localMetricValues.value = localMetricValues.value.map(function (mv) {
        if (!mv.period || !selectedPeriods.has(String(mv.period))) return mv;
        return _objectSpread(_objectSpread({}, mv), {}, {
          targetLocked: targetAffected ? shouldLock : mv.targetLocked,
          actualLocked: actualAffected ? shouldLock : mv.actualLocked
        });
      });
      emit('submit', {
        metricAssignmentIds: activeItems.value.map(function (entry) {
          return entry.id;
        }).filter(function (id) {
          return id !== null && id !== undefined;
        }),
        operation: lockOperation.value,
        scope: lockScope.value,
        years: lockYears.value,
        level: level,
        reason: reason || undefined
      });
    };
    return {
      __sfc: true,
      showDebugging: showDebugging,
      proxy: proxy,
      props: props,
      emit: emit,
      lockOperation: lockOperation,
      lockScope: lockScope,
      lockYears: lockYears,
      lockLevel: lockLevel,
      lockReason: lockReason,
      showReasonValidation: showReasonValidation,
      normalizeUserId: normalizeUserId,
      localMetricValues: localMetricValues,
      activeItems: activeItems,
      lockStatusRows: lockStatusRows,
      lockingLevelOptions: lockingLevelOptions,
      trimmedLockReason: trimmedLockReason,
      hasReason: hasReason,
      lockReasonErrors: lockReasonErrors,
      submit: submit
    };
  }
});